import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { GripType } from '../../api/models';

export type TABLE_TYPE = Table<GripType>;

export const TABLE = 'gripType';
const SCHEMA = 'gripTypeId, sortId';

class GripTypeDatabase implements DataRepository<GripType> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<GripType | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: GripType, key: Key): Promise<GripType> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: GripType[]): Promise<GripType[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<GripType[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const GripTypeDB = new GripTypeDatabase(db);
